import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FOLDER_HEADER_NAME } from '@services/generics/constants';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class PermissionsService {
    private _endpoint = '/odata/Users/UiPath.Server.Configuration.OData.GetCurrentPermissions';

    constructor(
        protected _http: HttpClient,
    ) { }

    public get(folderId?: number): Observable<string[]> {
        const headers: Record<string, string> = {};
        if (folderId != null) {
            headers[FOLDER_HEADER_NAME] = folderId.toString();
        }

        return this._http.get<{ Permissions: string[] }>(this._endpoint, { headers })
            .pipe(
                map(({ Permissions }) => Permissions),
            );
    }
}
